function Warehouse() {

}

export default Warehouse;